module.exports = __webpack_public_path__ + "static/media/log.20c262e0.svg";